// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host /deep/ .card-header{
    background: #F5F6FA;
    border-bottom: #D3D3D3 solid 1px;
    padding: 10px 18px;
}

:host /deep/ .card-header button{
    padding: 0;
    margin: 0;
    border: none;
}

:host /deep/ .card{
    border:none;
}

:host /deep/ .listItem{
    padding: 8px 0 8px 50px;
    border-bottom: #D3D3D3 solid 1px;
    margin: 0;
}

:host /deep/ .card-header .title{
    font-size:17px;
    font-weight: bold;
    color: #4D4F5C;
    text-decoration: none;
    position: relative;
}

:host /deep/ .card-header .btn-link{position:relative;}
:host /deep/ .card-header .btn-link:hover{
    text-decoration: none;
}

:host /deep/ .card-body{
    padding: 0px;
}

:host /deep/ .card-header .btn-link:after{
    transform: rotate(90deg);
    content: "";
    background: url(/assets/images/panel-arrow.svg) no-repeat center center;
    top: 5px;
	right:-18px;
    position: absolute;
    width: 20px;
    height: 19px;
    transition: all 0.5s ease;
    display: inline-block;
		right:-33px;
}

:host /deep/ .card-header .btn-link.collapsed:after{
    content: "";
    background: url(/assets/images/panel-arrow.svg) no-repeat center right;
    position: absolute;
    width: 20px;
    height: 19px;
    transition: all 0.5s ease;
    display: inline-block;
    transform: rotate(0deg);
	top:5px;

}

:host /deep/ .collapse.show{
    transition: all 0.5s ease;
}`, "",{"version":3,"sources":["webpack://./src/app/components/customer/intakes/add-intakes-data/basic/content/practice-info/practice-info.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,oCAAoC,iBAAiB,CAAC;AACtD;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,uEAAuE;IACvE,QAAQ;CACX,WAAW;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;EACvB,WAAW;AACb;;AAEA;IACI,WAAW;IACX,sEAAsE;IACtE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;CAC1B,OAAO;;AAER;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[":host /deep/ .card-header{\n    background: #F5F6FA;\n    border-bottom: #D3D3D3 solid 1px;\n    padding: 10px 18px;\n}\n\n:host /deep/ .card-header button{\n    padding: 0;\n    margin: 0;\n    border: none;\n}\n\n:host /deep/ .card{\n    border:none;\n}\n\n:host /deep/ .listItem{\n    padding: 8px 0 8px 50px;\n    border-bottom: #D3D3D3 solid 1px;\n    margin: 0;\n}\n\n:host /deep/ .card-header .title{\n    font-size:17px;\n    font-weight: bold;\n    color: #4D4F5C;\n    text-decoration: none;\n    position: relative;\n}\n\n:host /deep/ .card-header .btn-link{position:relative;}\n:host /deep/ .card-header .btn-link:hover{\n    text-decoration: none;\n}\n\n:host /deep/ .card-body{\n    padding: 0px;\n}\n\n:host /deep/ .card-header .btn-link:after{\n    transform: rotate(90deg);\n    content: \"\";\n    background: url(/assets/images/panel-arrow.svg) no-repeat center center;\n    top: 5px;\n\tright:-18px;\n    position: absolute;\n    width: 20px;\n    height: 19px;\n    transition: all 0.5s ease;\n    display: inline-block;\n\t\tright:-33px;\n}\n\n:host /deep/ .card-header .btn-link.collapsed:after{\n    content: \"\";\n    background: url(/assets/images/panel-arrow.svg) no-repeat center right;\n    position: absolute;\n    width: 20px;\n    height: 19px;\n    transition: all 0.5s ease;\n    display: inline-block;\n    transform: rotate(0deg);\n\ttop:5px;\n\n}\n\n:host /deep/ .collapse.show{\n    transition: all 0.5s ease;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
